<!--任务详情-->
<template>
  <div class="taskDetial">
    <div class="detialInner">
      <div v-if="formLabelAlign.status_text == 'Pay Difference'" style="display: flex">
        <div class="defaultBox changeStatus" style="margin-right: 16px">Awaiting Pickup</div>
        <div class="defaultBox changeStatus errStatus" style="left: 280px">{{formLabelAlign.status_text}}</div>
      </div>
      <div v-else>
        <div class="defaultBox changeStatus" :class="{successStatus: info.delivery_status === 1, errStatus: info.delivery_status === 2}">{{formLabelAlign.status_text}}</div>
      </div>
    </div>
    <div class="topPans">
      <el-tabs v-model="activeNames" stretch>
        <el-tab-pane label="Information" name="first">
          <el-scrollbar style="height: calc(100vh - 214px)" v-loading="detialLoading">
            <div class="paneOut">
              <el-form label-position="right" label-width="150px" :model="formLabelAlign">
                <div class="paneOne">
                  <el-form-item label="Tracking#: ">{{ formLabelAlign.order_no }}</el-form-item>
                  <el-form-item label="Creator's Acc.: ">{{ formLabelAlign.user_name }}</el-form-item>
                  <el-form-item label="Created at: ">{{ formLabelAlign.created_at }}</el-form-item>
                </div>
                <div class="paneOne paneTwo">
                  <div class="contact-info">
                    <el-form-item style="margin-bottom: 0">
                      <span slot="label" style="float: right">
                      <div class="icon">
                        <img src="../../assets/order/sender@2x.png" alt="User Icon">
                      </div>
                      </span>
                        <div class="info">
                          <h3>{{formLabelAlign.sender_name}}</h3>
                          <div class="inner_mess">{{formLabelAlign.sender_address}}<span v-if="formLabelAlign.sender_abs">,</span> {{formLabelAlign.sender_abs}}</div>
                          <div class="inner_mess">{{formLabelAlign.sender_city}}, {{formLabelAlign.sender_province}} {{formLabelAlign.sender_postal_code}}</div>
                          <div class="inner_mess">{{formLabelAlign.sender_full_phone}}</div>
                          <div class="inner_mess">{{formLabelAlign.sender_email}}</div>
                        </div>
                    </el-form-item>

                    <el-form-item style="margin-top: 8px">
                      <span slot="label" style="float: right">
                      <div class="icon">
                        <img src="../../assets/order/recipient@2x.png" alt="User Icon">
                      </div>
                      </span>
                      <div class="info">
                        <h3>{{formLabelAlign.receiver_name}}</h3>
                        <div class="inner_mess">{{formLabelAlign.receiver_address}}<span v-if="formLabelAlign.receiver_abs">,</span>{{formLabelAlign.receiver_abs}}</div>
                        <div class="inner_mess">{{formLabelAlign.receiver_city}}, {{formLabelAlign.receiver_province}} {{formLabelAlign.receiver_postal_code}}</div>
                        <div class="inner_mess">{{formLabelAlign.receiver_full_phone}}</div>
                        <div class="inner_mess">{{formLabelAlign.receiver_email}}</div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="paneOne">
                  <el-form-item label="Parcel type:  ">{{ formLabelAlign.parcel_type_text }}</el-form-item>
                  <el-form-item label="Parcel Size:">{{ formLabelAlign.parcel_size_text }}</el-form-item>
                </div>

                <div class="paneOne">
                  <el-form-item label="Pickup special requirements:  ">
                    <span v-if="formLabelAlign.sender_note">{{ formLabelAlign.sender_note }}</span><span v-else style="color: #999999;">No filled</span>
                  </el-form-item>
                  <el-form-item label="Delivery special requirements: ">
                    <span v-if="formLabelAlign.receiver_note">{{ formLabelAlign.receiver_note }}</span><span v-else
                                                                                                             style="color: #999999;">Not filled</span>
                  </el-form-item>
                </div>
                <div class="paneOne">
                  <el-form-item label="Order Subtotal:">{{ formLabelAlign.pay_info?.order_subtotal }}</el-form-item>
                  <el-form-item label="Coupon:">{{ formLabelAlign.pay_info?.coupon }}</el-form-item>
                  <el-form-item label="HST:">{{formLabelAlign.pay_info?.hst}}</el-form-item>
                  <el-form-item label="Amount Paid:">{{formLabelAlign.pay_info?.amount_paid}}</el-form-item>
                  <el-form-item label="Payment method: ">{{formLabelAlign.pay_info?.payment_method}}</el-form-item>
                  <el-form-item label="Payment time:">{{formLabelAlign.pay_info?.payment_time}}</el-form-item>
                  <el-form-item label="Adjustment Sub.:">{{formLabelAlign.pay_info?.adjustment_sub}}</el-form-item>
                  <el-form-item label="Adjustment HST.:">{{formLabelAlign.pay_info?.adjustment_hst}}</el-form-item>
                  <el-form-item label="Adjustment Paid:">{{formLabelAlign.pay_info?.adjustment_amount_paid}}</el-form-item>
                  <el-form-item label="Adjust. PM:">{{formLabelAlign.pay_info?.adjustment_payment_method}}</el-form-item>
                  <el-form-item label="Adjust. PT:">{{ formLabelAlign.pay_info?.adjustment_payment_time }}</el-form-item>
                  <el-form-item label="Refunded Amt.: " v-if=" formLabelAlign.pay_info?.total_refunded ">
                   {{ formLabelAlign.pay_info?.total_refunded }}
                    <div v-if="formLabelAlign.pay_info?.total_refunded!= 'N/A'" @click="showRefund(formLabelAlign.pay_info?.refund_records)" class="inline-block mr-2" style="border-bottom:1px solid #1F2D42;cursor: pointer">Notes</div>
                  </el-form-item>
                </div>
                <div class="changeTime">
                  <el-form-item label="Timeline">
                    <div>
                      <el-timeline :reverse="reverse">
                        <el-timeline-item
                          v-for="(activity, index) in formLabelAlign.timeline"
                          :key=" 'time'+ index"
                          :color="activity.color"
                          placement="top"
                          :timestamp="activity.status">
                          {{ activity.time }}
                          <div class="time_line_img">
                            <div  v-if="activity.status == 'Picked up'" style="margin-top: 8px">
                              <el-image v-for="(i,v) in formLabelAlign.pickup_photo_urls" :key="'pickup' + v" :src="i"></el-image>
                            </div>
                            <div  v-if="activity.status == 'Failed' || activity.status == 'Delivery'"  style="margin-top: 8px">
                              <el-image v-for="(i,v) in formLabelAlign.delivery_photo_urls" :key="'delivery' + v" :src="i"></el-image>
                            </div>
                          </div>
                          <div style="margin-top: 4px"  v-if="activity.driver">
                            <div>Driver: {{ activity.driver }}</div>
                          </div>
                          <div style="margin-top: 4px">
                            <div>{{activity.amount}}</div>
                            <div v-if="activity.notes">{{ activity.notes }}</div>
                            <div style="margin-top: 4px" v-if="activity.failure_reason">Reason: {{activity.failure_reason}}</div>
                            <div style="margin-top: 4px">{{activity.operator}}</div>
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-scrollbar>
          <div>
            <div class="edit_button">
              <el-button type="success" @click="openOrderDialogHandle('note')" >Note</el-button>
              <el-button :disabled="formLabelAlign.status> 4" type="primary" @click="openOrderDialogHandle('cancel')" round class="btn-custom-red" style="width: 80px;padding: 0;margin-right: 16px">Cancel</el-button>
              <el-button :disabled="formLabelAlign.status == 7"  class="changeFocus" @click="openOrderDialogHandle('refund')" >Refund</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Proof" name="third">
          <el-scrollbar style="height: calc(100vh - 200px)">
            <div class="paneImg" style="margin-top: 24px">
              <div v-if="formLabelAlign.pickup_photo_urls || formLabelAlign.delivery_photo_urls ">
                <el-image v-for="(i,v) in formLabelAlign.pickup_photo_urls" :key="'pickup' + v" :src="i"></el-image>
                <el-image v-for="(i,v) in formLabelAlign.delivery_photo_urls" :key="'delivery' + v" :src="i"></el-image>
              </div>
              <div v-else class="empty">
<!--                <img src="../../assets/list_blank.png" alt="">-->
                <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
              </div>
            </div>
          </el-scrollbar>
        </el-tab-pane>

      </el-tabs>
    </div>
    <!--    退款记录-->
    <el-dialog
      :modal="false"
      style="padding-top: 0"
      title="Records for refund"
      :visible.sync="refundDetialDialog"
      width="35%">
      <div class="mt-4">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in refundTimeline"
            :key="index"
            :color="activity.color"
            placement="top"
            :timestamp="activity.title">
            <div>
               {{activity.amount}}
            </div>
            <div style="margin-top: 4px">
              <div v-if="activity.notes">{{ activity.notes }}</div>
            </div>
            <div>
              {{activity.operator}}
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" round style="width: 80px;padding: 0"  @click="refundDetialDialog = false">Ok</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {getOrderDetail} from "@/api/order";

export default {
  name: "taskDetial",
  data() {
    return {
      refundDetialDialog:false,
      activeNames: 'first',
      formLabelAlign: {},
      detialLoading: false,
      reverse: false,
      refundTimeline:{},
    }
  },
  props: {
    info: {
      default: {}
    },
    show_tag:{
      default: ''
    }
  },
  watch:{
    show_tag:{
      handler(newValue, oldValue) {
        this.refundDetialDialog = false
        this.activeNames = newValue
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // this.getOrderDetialHandle()
  },
  methods: {
    refundDetialDialogHandle(){
      this.refundDetialDialog = false
    },
    showRefund(arr){
      console.log(arr,'arr')
      this.refundTimeline = arr
      this.refundDetialDialog = true
    },
    openOrderDialogHandle(e){
      let str = e
      e = {...this.formLabelAlign}
      e.type = str
      this.$emit("openOrderDialogHandle",e);
    },
    getOrderDetialHandle(){
      this.detialLoading = true
      getOrderDetail({
        id:this.info.id
      }).then(res => {
        this.detialLoading = false
        if (res.code == 200) {
          this.formLabelAlign = res.data;
          if (this.formLabelAlign.pickup_photo_urls) {
            let pickup_photo_urls = JSON.parse(this.formLabelAlign.pickup_photo_urls);
            this.formLabelAlign.pickup_photo_urls = pickup_photo_urls.map(item => 'https://plus.escroud.com' + item);
          }
          if (this.formLabelAlign.delivery_photo_urls) {
            let delivery_photo_urls = JSON.parse(this.formLabelAlign.delivery_photo_urls);
            this.formLabelAlign.delivery_photo_urls = delivery_photo_urls.map(item => 'https://plus.escroud.com' + item);
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
  @import "../order-detail/order-detial";

</style>
